var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-notes loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("csp-table", {
                ref: "noteTable",
                attrs: {
                  "default-page-options": _vm.defaultPageOptions,
                  "default-per-page": _vm.defaultPerPage,
                  "disable-filters": _vm.disableFilters,
                  "disable-pagination": _vm.disablePagination,
                  icon: "inticon-comment",
                  "item-detail-id-label": ".",
                  "item-detail-url": ".",
                  "items-ajax-url": _vm.urlForTableData,
                  "legacy-data-structure": true,
                  "rows-selectable": false,
                  "table-headline": "Kommunikation",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "above-filter",
                      fn: function () {
                        return [
                          _vm.permissions?.canCreateCallback
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "float-right ml-1 mb-2",
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.createCallbackNote },
                                },
                                [
                                  _vm._v(
                                    "\n                        Rückrufbitte\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.createModalAvailable
                            ? _c("csp-record-detail-notes-create", {
                                staticClass: "float-right",
                                attrs: {
                                  "create-child-for": _vm.createChildForNoteId,
                                  "form-context": _vm.creationFormContext,
                                  "hide-for-group-options":
                                    _vm.hideForGroupOptions,
                                  "record-id": _vm.recordId,
                                },
                                on: {
                                  created: function ($event) {
                                    return _vm.$refs.noteTable.loadRecords()
                                  },
                                  reset: _vm.resetNoteCreation,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("csp-responsible-insurance-modal", {
                            staticClass: "float-right mr-1 mb-2",
                            attrs: { "record-id": _vm.recordId },
                            on: {
                              "trigger-notes-reload": function ($event) {
                                return _vm.$refs.noteTable.loadRecords()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clear-float" }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "cell(actions)",
                      fn: function (item) {
                        return [
                          _c(
                            "div",
                            { staticClass: "table-actions" },
                            [
                              item.data.canBeCompleted
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        title: "Als erledigt markieren",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.markComplete(
                                            item.data.damageRecordNoteId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_done",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.data.canCreateChildNote
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        title: "Auf diesen Vermerk antworten",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.createChildNote(
                                            item.data.damageRecordNoteId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_plus",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.data.canBeDeleted
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#", title: "Löschen" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.deleteNote(
                                            item.data.damageRecordNoteId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_delete",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.data.canIndexNoteFiles
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        title: "Verknüpfte Dateien anzeigen",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.showFilesModal =
                                            item.data.damageRecordNoteId
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "inticon-autoclaim_atachements",
                                        },
                                        [
                                          item.data.files > 0
                                            ? _c("span", { staticClass: "dot" })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showFilesModal ===
                              item.data.damageRecordNoteId
                                ? _c("csp-record-detail-notes-document-list", {
                                    attrs: {
                                      "hide-for-group-options":
                                        _vm.hideForGroupOptions,
                                      "note-id": parseInt(
                                        item.data.damageRecordNoteId
                                      ),
                                      "record-id": _vm.recordId,
                                    },
                                    on: {
                                      reset: function ($event) {
                                        _vm.showFilesModal = null
                                      },
                                      "upload-success": function ($event) {
                                        return _vm.$refs.noteTable.loadRecords()
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.data.canIndexRecipients
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        title: "Empfänger anzeigen",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.showRecipientsModal =
                                            item.data.damageRecordNoteId
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_sent",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showRecipientsModal ===
                              item.data.damageRecordNoteId
                                ? _c("csp-record-detail-notes-recipient-list", {
                                    attrs: {
                                      "note-id": parseInt(
                                        item.data.damageRecordNoteId
                                      ),
                                      "record-id": _vm.recordId,
                                    },
                                    on: {
                                      reset: function ($event) {
                                        _vm.showRecipientsModal = null
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.data.canUnsetPriority
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        title: "Priorisierung aufheben",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.removePriority(
                                            item.data.damageRecordNoteId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_prio",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "below-body",
                      fn: function () {
                        return [_vm._t("below-body")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }